import API_ENDPOINTS from '../api/endpoints';
import apiClient from '../api/apiClient';

// Job Services 
export const postJob = async (jobData) => {
    try {
        const response = await apiClient.post(API_ENDPOINTS.JOBS.CREATE_JOB, jobData, {
            headers: {
                'Content-Type': 'multipart/form-data', // important if you're sending images
            },
        });
        return response.data; // Return just the data
    } catch (error) {
        console.error("Failed to post job:", error);
        console.log("Server error response:", error?.response?.data);
    }
};

export const updateJob = async (jobId, updatedData) => {
    try {
        const response = await apiClient.patch(
            `${API_ENDPOINTS.JOBS.UPDATE_JOB}${jobId}/`,
            updatedData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error updating job:", error);
        throw error;
    }
};

export const deleteJob = async (jobId) => {
    try {
        const response = await apiClient.delete(`${API_ENDPOINTS.JOBS.DELETE_JOB}${jobId}/`);
        return response.data;
    } catch (error) {
        console.error("Error deleting job:", error);
        throw error;
    }
};

export const getUserJobs = async () => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.JOBS.USER_JOBS);
        return response.data; // Return only the data
    } catch (error) {
        console.error("Failed to fetch user jobs:", error);
        console.log("Server error response:", error?.response?.data);
        throw error;
    }
};

export const getPublicUserJobs = async (profileId) => {
  try {
    const response = await apiClient.get(`${API_ENDPOINTS.JOBS.PUBLIC_PROFILE_JOBS}${profileId}/`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch public user jobs:", error);
    throw error;
  }
};

export const getAllJobs = async () => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.JOBS.VIEW_ALL_JOBS);
        return response.data;
    } catch (error) {
        console.error("Failed to fetch all jobs:", error);
        console.log("Server error response:", error?.response?.data);
        throw error;
    }
};

export const searchJobs = async ({ query, page = 1, pageSize = 10 }) => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.JOBS.SEARCH, {
            params: {
                q: query || "",
                page,
                page_size: pageSize,
            },
        });

        return response.data; 
    } catch (error) {
        console.error("Failed to search jobs:", error);
        console.log("Server error response:", error?.response?.data);
        throw error;
    }
};

export const getJobById = async (id) => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.JOBS.VIEW_JOB(id));
        return response.data;
    } catch (error) {
        console.error(`Failed to fetch job with id ${id}:`, error);
        console.log("Server error response:", error?.response?.data);
        throw error;
    }
};

export const toggleJobStatus = async (jobId) => {
    try {
        const response = await apiClient.patch(API_ENDPOINTS.JOBS.TOGGLE_STATUS(jobId));
        return response.data;
    } catch (error) {
        console.error(`Failed to toggle job status for job ${jobId}:`, error);
        console.log("Server error response:", error?.response?.data);
        throw error;
    }
};

export const toggleJobLike = async (jobId) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.JOBS.TOGGLE_LIKE(jobId)); // <-- POST
    return response.data;
  } catch (error) {
    console.error(`Failed to toggle like for job ${jobId}:`, error);
    console.log("Server error response:", error?.response?.data);
    throw error;
  }
};